// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type CmsIntegrationsForSiteQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  connected?: Types.Maybe<Types.Scalars['Boolean']>;
}>;


export type CmsIntegrationsForSiteQuery = (
  { __typename?: 'Query' }
  & { cmsIntegrationsForSite?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'CmsProvider' }
    & Pick<Types.CmsProvider, 'id' | 'name' | 'formattedName' | 'logoUrl' | 'details' | 'description' | 'connected'>
    & { features?: Types.Maybe<(
      { __typename?: 'IntegrationFeatures' }
      & Pick<Types.IntegrationFeatures, 'envVars' | 'webhooks' | 'extension'>
    )> }
  )>>> }
);

export type ActiveCmsIntegrationsForSiteQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type ActiveCmsIntegrationsForSiteQuery = (
  { __typename?: 'Query' }
  & { activeCmsIntegrationsForSite?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'CmsIntegration' }
    & Pick<Types.CmsIntegration, 'id' | 'resourceId' | 'vendor' | 'status' | 'config' | 'environmentVariablesFeatureStatus' | 'webhookFeatureStatus' | 'extensionFeatureStatus'>
  )>>> }
);

export type EarlyAccessRequestDataQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  organizationId: Types.Scalars['UUID'];
}>;


export type EarlyAccessRequestDataQuery = (
  { __typename?: 'Query' }
  & { currentUser?: Types.Maybe<(
    { __typename?: 'User' }
    & Pick<Types.User, 'id' | 'name' | 'email'>
  )>, siteDetails?: Types.Maybe<(
    { __typename?: 'Site' }
    & Pick<Types.Site, 'id' | 'name' | 'publicName'>
  )>, organizationDetails?: Types.Maybe<(
    { __typename?: 'Organization' }
    & Pick<Types.Organization, 'id' | 'name'>
    & { billing?: Types.Maybe<(
      { __typename?: 'BillingInformation' }
      & Pick<Types.BillingInformation, 'id'>
      & { plan?: Types.Maybe<(
        { __typename?: 'SubscriptionPlan' }
        & Pick<Types.SubscriptionPlan, 'id'>
        & { baseFeatures?: Types.Maybe<(
          { __typename?: 'BaseFeatures' }
          & Pick<Types.BaseFeatures, 'tier'>
        )> }
      )> }
    )> }
  )> }
);

export type GatsbyDependenciesForSiteQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type GatsbyDependenciesForSiteQuery = (
  { __typename?: 'Query' }
  & { gatsbyDependenciesForSite?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'GatsbyDependency' }
    & Pick<Types.GatsbyDependency, 'name' | 'installedVersion'>
  )>>> }
);


export const CmsIntegrationsForSiteDocument = gql`
    query CmsIntegrationsForSite($siteId: UUID!, $connected: Boolean) {
  cmsIntegrationsForSite(siteId: $siteId, connected: $connected) {
    id
    name
    formattedName
    logoUrl
    details
    description
    connected
    features {
      envVars
      webhooks
      extension
    }
  }
}
    `;

/**
 * __useCmsIntegrationsForSiteQuery__
 *
 * To run a query within a React component, call `useCmsIntegrationsForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsIntegrationsForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsIntegrationsForSiteQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      connected: // value for 'connected'
 *   },
 * });
 */
export function useCmsIntegrationsForSiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CmsIntegrationsForSiteQuery, CmsIntegrationsForSiteQueryVariables>) {
        return ApolloReactHooks.useQuery<CmsIntegrationsForSiteQuery, CmsIntegrationsForSiteQueryVariables>(CmsIntegrationsForSiteDocument, baseOptions);
      }
export function useCmsIntegrationsForSiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CmsIntegrationsForSiteQuery, CmsIntegrationsForSiteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CmsIntegrationsForSiteQuery, CmsIntegrationsForSiteQueryVariables>(CmsIntegrationsForSiteDocument, baseOptions);
        }
export type CmsIntegrationsForSiteQueryHookResult = ReturnType<typeof useCmsIntegrationsForSiteQuery>;
export type CmsIntegrationsForSiteLazyQueryHookResult = ReturnType<typeof useCmsIntegrationsForSiteLazyQuery>;
export type CmsIntegrationsForSiteQueryResult = ApolloReactCommon.QueryResult<CmsIntegrationsForSiteQuery, CmsIntegrationsForSiteQueryVariables>;
export const ActiveCmsIntegrationsForSiteDocument = gql`
    query ActiveCmsIntegrationsForSite($siteId: UUID!) {
  activeCmsIntegrationsForSite(siteId: $siteId) {
    id
    resourceId
    vendor
    status
    config
    environmentVariablesFeatureStatus
    webhookFeatureStatus
    extensionFeatureStatus
  }
}
    `;

/**
 * __useActiveCmsIntegrationsForSiteQuery__
 *
 * To run a query within a React component, call `useActiveCmsIntegrationsForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveCmsIntegrationsForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveCmsIntegrationsForSiteQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useActiveCmsIntegrationsForSiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActiveCmsIntegrationsForSiteQuery, ActiveCmsIntegrationsForSiteQueryVariables>) {
        return ApolloReactHooks.useQuery<ActiveCmsIntegrationsForSiteQuery, ActiveCmsIntegrationsForSiteQueryVariables>(ActiveCmsIntegrationsForSiteDocument, baseOptions);
      }
export function useActiveCmsIntegrationsForSiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActiveCmsIntegrationsForSiteQuery, ActiveCmsIntegrationsForSiteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ActiveCmsIntegrationsForSiteQuery, ActiveCmsIntegrationsForSiteQueryVariables>(ActiveCmsIntegrationsForSiteDocument, baseOptions);
        }
export type ActiveCmsIntegrationsForSiteQueryHookResult = ReturnType<typeof useActiveCmsIntegrationsForSiteQuery>;
export type ActiveCmsIntegrationsForSiteLazyQueryHookResult = ReturnType<typeof useActiveCmsIntegrationsForSiteLazyQuery>;
export type ActiveCmsIntegrationsForSiteQueryResult = ApolloReactCommon.QueryResult<ActiveCmsIntegrationsForSiteQuery, ActiveCmsIntegrationsForSiteQueryVariables>;
export const EarlyAccessRequestDataDocument = gql`
    query EarlyAccessRequestData($siteId: UUID!, $organizationId: UUID!) {
  currentUser {
    id
    name
    email
  }
  siteDetails(id: $siteId) {
    id
    name
    publicName
  }
  organizationDetails(id: $organizationId) {
    id
    name
    billing {
      id
      plan {
        id
        baseFeatures {
          tier
        }
      }
    }
  }
}
    `;

/**
 * __useEarlyAccessRequestDataQuery__
 *
 * To run a query within a React component, call `useEarlyAccessRequestDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEarlyAccessRequestDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEarlyAccessRequestDataQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useEarlyAccessRequestDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EarlyAccessRequestDataQuery, EarlyAccessRequestDataQueryVariables>) {
        return ApolloReactHooks.useQuery<EarlyAccessRequestDataQuery, EarlyAccessRequestDataQueryVariables>(EarlyAccessRequestDataDocument, baseOptions);
      }
export function useEarlyAccessRequestDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EarlyAccessRequestDataQuery, EarlyAccessRequestDataQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<EarlyAccessRequestDataQuery, EarlyAccessRequestDataQueryVariables>(EarlyAccessRequestDataDocument, baseOptions);
        }
export type EarlyAccessRequestDataQueryHookResult = ReturnType<typeof useEarlyAccessRequestDataQuery>;
export type EarlyAccessRequestDataLazyQueryHookResult = ReturnType<typeof useEarlyAccessRequestDataLazyQuery>;
export type EarlyAccessRequestDataQueryResult = ApolloReactCommon.QueryResult<EarlyAccessRequestDataQuery, EarlyAccessRequestDataQueryVariables>;
export const GatsbyDependenciesForSiteDocument = gql`
    query gatsbyDependenciesForSite($siteId: UUID!) {
  gatsbyDependenciesForSite(siteId: $siteId) {
    name
    installedVersion
  }
}
    `;

/**
 * __useGatsbyDependenciesForSiteQuery__
 *
 * To run a query within a React component, call `useGatsbyDependenciesForSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGatsbyDependenciesForSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGatsbyDependenciesForSiteQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGatsbyDependenciesForSiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GatsbyDependenciesForSiteQuery, GatsbyDependenciesForSiteQueryVariables>) {
        return ApolloReactHooks.useQuery<GatsbyDependenciesForSiteQuery, GatsbyDependenciesForSiteQueryVariables>(GatsbyDependenciesForSiteDocument, baseOptions);
      }
export function useGatsbyDependenciesForSiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GatsbyDependenciesForSiteQuery, GatsbyDependenciesForSiteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GatsbyDependenciesForSiteQuery, GatsbyDependenciesForSiteQueryVariables>(GatsbyDependenciesForSiteDocument, baseOptions);
        }
export type GatsbyDependenciesForSiteQueryHookResult = ReturnType<typeof useGatsbyDependenciesForSiteQuery>;
export type GatsbyDependenciesForSiteLazyQueryHookResult = ReturnType<typeof useGatsbyDependenciesForSiteLazyQuery>;
export type GatsbyDependenciesForSiteQueryResult = ApolloReactCommon.QueryResult<GatsbyDependenciesForSiteQuery, GatsbyDependenciesForSiteQueryVariables>;
